{
  "dismiss": "Hylkää"
}